import { Modal as ModalModule } from 'common';
import React, { useContext, useEffect, useState } from 'react';
import HistoryCommunication from '../utils/HistoryCommunication';

const { Modal, ModalContext } = ModalModule;

const CheckClaimStatusModal = ({ modalId, data: { universalPostageId } }) => {
	const [claimStatusUrl, setClaimStatusUrl] = useState('');
	const { showError } = useContext(ModalContext);

	const fetchClaimStatusUrl = async () => {
		const response = await HistoryCommunication.getUrl({
			urlType: 'ParcelGuardClaimStatus',
			applicationContext: universalPostageId,
		});

		if (HistoryCommunication.isSuccessful(response)) {
			setClaimStatusUrl(response.data);
		} else {
			showError({
				response,
			});
		}
	};

	useEffect(() => {
		fetchClaimStatusUrl();
	}, []);

	return (
		<Modal
			modalId={modalId}
			className="history-claim-form check-claim-status-modal"
			header="Check Claim Status"
			fullHeight
			hideFooter
		>
			<iframe
				className="check-claim-status-iframe"
				title="Check Claim Status"
				src={claimStatusUrl}
			/>
		</Modal>
	);
};

export default CheckClaimStatusModal;
